import { render, staticRenderFns } from "./ActiveFormsGrid.vue?vue&type=template&id=1c831a9e"
import script from "./ActiveFormsGrid.vue?vue&type=script&lang=js"
export * from "./ActiveFormsGrid.vue?vue&type=script&lang=js"
import style0 from "./ActiveFormsGrid.vue?vue&type=style&index=0&id=1c831a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports